export class StripeHelpers {
  /**
   *
   * @param {Object} error - Stripe error object
   */
  static errorHandler({ error }) {
    if (error) {
      throw error;
    }
  }
}
